"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const LoaderUI_1 = require("../../Components/Loader/LoaderUI");
const Druid_1 = require("../../Druid");
const Debounce_1 = require("../../Utility/Decorator/Debounce");
class Loader {
    constructor(element) {
        this.timeout = 0;
        this.setElement(element);
    }
    /**
     * Set element to attach to
     */
    setElement(element) {
        var _a;
        if (element === undefined) {
            this.element = undefined;
            return this;
        }
        // if element is part of a table, the loader will not present properly. Use the table parent as target element
        if (['TBODY', 'THEAD', 'TR', 'TD', 'TH'].includes(element.tagName)) {
            element = (_a = element.closest('table')) !== null && _a !== void 0 ? _a : undefined;
        }
        this.element = element;
        return this;
    }
    /**
     * Show loader over element. Debounce with 1 milliseconds to avoid dimension calculation issues when the element might
     * be still invisible.
     */
    start() {
        var _a, _b;
        if (this.element === undefined || this.element.parentNode === null) {
            return;
        }
        if (this.elements === undefined) {
            this.elements = LoaderUI_1.default.create();
        }
        // make sure the load has been stopped
        this.cleanup();
        this.element.parentNode.insertBefore(this.elements.anchor, this.element);
        // match curtain width and height to element's
        this.elements.curtain.style.width = this.element.scrollWidth + 'px';
        this.elements.curtain.style.height = this.element.scrollHeight + 'px';
        this.elements.curtain.classList.add((_b = (_a = Druid_1.default.configuration().loader) === null || _a === void 0 ? void 0 : _a.fadeInClass) !== null && _b !== void 0 ? _b : 'fade-in');
        // position curtain correctly over element
        const positionA = this.elements.anchor.getPosition();
        const positionB = this.element.getPosition();
        this.elements.curtain.style.top = (positionB.y - positionA.y) + 'px';
        this.elements.curtain.style.left = (positionB.x - positionA.x) + 'px';
    }
    /**
     * Stop loader over element and remove it from the document
     */
    stop() {
        var _a, _b;
        if (this.elements === undefined) {
            return this;
        }
        // when transition ends, remove anchor
        this.elements.curtain.addEventListener('transitionend', () => this.cleanup());
        this.elements.curtain.classList.remove((_b = (_a = Druid_1.default.configuration().loader) === null || _a === void 0 ? void 0 : _a.fadeInClass) !== null && _b !== void 0 ? _b : 'fade-in');
        // no faith in transitionend, make sure it's always removed
        this.timeout = window.setTimeout(() => this.cleanup(), 250);
        return this;
    }
    /**
     * Cleanup the event listeners and anchor
     */
    cleanup() {
        if (this.timeout !== 0) {
            window.clearTimeout(this.timeout);
            this.timeout = 0;
        }
        if (this.elements !== undefined) {
            this.elements.curtain.removeEventListeners('transitionend');
            this.elements.anchor.remove();
        }
    }
}
exports.default = Loader;
__decorate([
    (0, Debounce_1.default)(1)
], Loader.prototype, "start", null);
//# sourceMappingURL=Loader.js.map